import React from "react";
import Hero from "../components/Hero";
import AIPerformance from "../components/AIPerformance/AIPerformance";
import FAQ from "../components/FAQ/FAQ";
import Footer from "../components/Footer/Footer";
import MatrixBackground from "../components/MatrixBackground/MatrixBackground";

const Home: React.FC = () => {
  return (
    <div className="relative min-h-screen bg-[#FAFAFA]">
      <div className="absolute inset-0 z-0">
        <MatrixBackground fontSize="md" endAtSection="#faq-section" />
      </div>
      <div className="relative z-20">
        <Hero />
        <AIPerformance />
        <div id="faq-section">
          <FAQ />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
